import React from 'react';
import clientImg from '../img/client.jpg'
import JointCommission from './JointCommission';

function Careers() {
  return (
    <>
    <div className="breadcrumb-area gradient-bg bg-cover shadow dark text-light text-center" style={{backgroundImage: `url(${clientImg})`}}>
        <div className="container">
            <div className="row">
                <div className="col-lg-8 offset-lg-2">
                    <h1>Careers</h1>
                    <ul className="breadcrumb">
                        <li><a href="/"><i className="fas fa-home"></i> Home</a></li>
                        <li className="active">Careers</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>

    <div className="blog-area single full-blog right-sidebar default-padding">
        <div className="container">
            <div className="blog-items">
                <div className="row">
                    <div className="blog-content col-lg-8 col-md-12">
                        
                        <div className="single-item">

                            <div className="blog-item-box">
                                <div className="item">
                                    <div className="info">
                                        
                                        <p>
                                           Divine CHP Staffing is the best staffing agency in the Triangle. We currently offer flexible per diem, contract, or travel positions. We value your personal growth and goals, and we treat our staff as family. We understand the importance of work-life balance; therefore, at Divine CHP Staffing you make your own schedule. We offer competitive weekly pay for CNAs/Sitters, LPNs, RNs, NP/PA, MD/DO and all other allied health.  
                                        </p>
                                        
                                        <blockquote>
                                           Join the Divine CHP Staffing family! Contact us today at 919-972-1964 
                                        </blockquote>
                                        
                                        <h5><i><b>Our recruitment procedure include but is not limited to the following stages;</b></i></h5>

                                        <ul>
                        									<li>	Online or In-person application</li>
                        									<li> At least 6 months of experience in your selected field </li>
                        									<li> Valid License for healthcare Providers (CNAs, LPNs, RNs, NP/Pas, MD/DOs…)</li>
                        									<li> Two (02) forms of ID</li>
                        									<li> Up to date immunization including (MMR, Varicella, Hep B, Flu, Tdap/TD booster)</li>
                        									<li> TB Test</li>
                        									<li> BLS/CPR from AHA or ARC</li>
                        									<li> Interview</li>
                        									<li> Competency Test</li>
                        									<li> Drug Screen</li>
                        									<li> Background check</li>
                        									<li> Three (03) References Check</li>
                        									 <li>All applicants must be eligible to work in the United States </li>
                        						    </ul>

                        								<p>	Please feel free to <a href="contact">contact us</a>  at 919 972 1964 if you need further information. </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="sidebar col-lg-4 col-md-12">
                        <aside>
                            <JointCommission />
                            <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: '100px'}}>
                                <a className="btn btn-md btn-gradient" href="apply">Click here to apply</a>
                            </div>
                        </aside>
                    </div>

                </div>
            </div>
        </div>
    </div>

    </>
  );
}

export default Careers;